import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Custom hook to handle feature flags via URL params and localStorage
 * @param flagName - The name of the feature flag (e.g., "tour", "playground")
 * @returns boolean indicating if the feature is enabled
 */
export const useFeatureFlag = (flagName: string): boolean => {
  const [searchParams] = useSearchParams();

  // Check URL param first, then localStorage
  const isEnabled =
    searchParams.get(flagName) === "true" || localStorage.getItem(flagName) === "true";

  useEffect(() => {
    const paramValue = searchParams.get(flagName);

    // If URL param is set to true, persist to localStorage
    if (paramValue === "true") {
      localStorage.setItem(flagName, "true");
    }
    // If URL param is set to false, remove from localStorage
    else if (paramValue === "false") {
      localStorage.removeItem(flagName);
    }
  }, [flagName, searchParams]);

  return isEnabled;
};
